import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useIntl } from 'react-intl';
import { IUserNotification } from 'interfaces/userNotification.interfaces';
import { colors } from 'common/ui/theme/default';
import unMessages from 'common/messages/userNotifications';
import UserNotificationsMenuItem from './UserNotificationsMenuItem';

const useStyles = makeStyles(() => ({
  menuItemsContainer: {
    scrollbarGutter: 'stable',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: '20px',
    '&::-webkit-scrollbar-track': {
      marginBottom: '-20px',
    },
  },
  menuItems: {
    padding: '0 1px 0 16px',
  },
  menuItemsInfo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    padding: '20px',
    fontSize: '14px',
    fontWeight: 400,
    color: colors.text.mediumGray,
  },
}));

interface IUserNotificationsMenu {
  userNotifications: IUserNotification[];
  groupStatus: 'all' | 'unread';
}

const UserNotificationsMenu: FC<IUserNotificationsMenu> = ({ userNotifications, groupStatus }) => {
  const classes = useStyles();
  const intl = useIntl();

  if (!userNotifications.length) {
    return (
      <div className={classes.menuItemsInfo}>
        {groupStatus === 'unread'
          ? intl.formatMessage(unMessages.userNotificationsUnreadEmpty)
          : intl.formatMessage(unMessages.userNotificationsAnyEmpty)}
      </div>
    );
  }

  return (
    <div className={classes.menuItemsContainer}>
      <div className={classes.menuItems}>
        {userNotifications.map(userNotification => {
          return (
            <UserNotificationsMenuItem
              key={userNotification.id}
              userNotification={userNotification}
            />
          );
        })}
      </div>

      <div className={classes.menuItemsInfo}>
        {intl.formatMessage(unMessages.userNotificationsInfo)}
      </div>
    </div>
  );
};

export default UserNotificationsMenu;
